import { USER_SET_USERS, USER_APPLY_FILTER } from './constants';
import { fetchAllUsersOfCurrentOrg } from '../api/users';
import { UserManagementUserActionTypes } from 'src/reducers/userManagementReducer';

export const fetchUsers = () => async (dispatch) => {
  const response = await fetchAllUsersOfCurrentOrg();
  const users = response.data;
  dispatch({
    users,
    type: USER_SET_USERS,
  });
};
export const applyFilters = (
  filters: UserManagementUserActionTypes['filters'],
  key: UserManagementUserActionTypes['key']
) => async (dispatch) => {
  dispatch({
    filters,
    key,
    type: USER_APPLY_FILTER,
  });
};
